import requestConfig from 'Models/uiConfig/requestConfig.js';
import { convertibleFromObject } from 'Modules/converter/index.js';
import { GET } from './common/httpClient.js';

import type { ServerModel } from 'Modules/serverApi/types.ts';

const { requestDefaults } = requestConfig;

export default async function fitments(productId: string): Promise<ServerModel.FitmentsResponseType> {
  const extra = { ...requestDefaults.extra };

  return await GET('ymm/fitments.json', {
    productId,
    extra: await convertibleFromObject(extra),
  })
    .then((response) => {
      return response as ServerModel.FitmentsResponseType;
    })
    .catch((err) => {
      throw `[Convermax]: The fitments request failed: ${err?.message}`;
    });
}
